import { render } from "./activity.vue?vue&type=template&id=60b73618&scoped=true"
import script from "./activity.vue?vue&type=script&lang=js"
export * from "./activity.vue?vue&type=script&lang=js"

import "./activity.vue?vue&type=style&index=0&id=60b73618&lang=scss&scoped=true"
import "./activity.vue?vue&type=style&index=1&id=60b73618&lang=css"

import exportComponent from "D:\\workCode\\web-middleground\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60b73618"]])

export default __exports__